// components/VideoPlayer/MobileFullscreenPrompt.jsx

import React from "react";
import ReactDOM from "react-dom";
import { useVideo } from "../../context/VideoContext";
import { getPortalContainer } from "../../utils/portalContainer";
import "./MobileFullscreenPrompt.css";

const MobileFullscreenPrompt = ({
  isOpen,
  onAccept,
  onDecline,
  title = "پخش تمام صفحه",
  bodyText2 = "برای تجربه بهتر، تماشا در حالت تمام صفحه پیشنهاد می‌شود.",
  acceptText = "تماشای تمام صفحه",
  declineText = "ادامه به همین صورت",
}) => {
  const { isFullscreen, isIOS } = useVideo();

  if (!isOpen) return null;

  // کلیک روی بک‌دراپ: هیچ کاری نکن
  const handleBackdropClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    // هیچ کاری نمیکنه - کاربر فقط میتونه دکمه‌ها رو بزنه
  };

  // کلیک روی خود کادر: نذار به بک‌دراپ برسه
  const handlePromptClick = (e) => {
    e.stopPropagation();
  };

  // پورتال به بیرون از video-wrapper تا اورلی همیشه روی کل ویوپورت دیده شود.
  // بدون این، transform روی .video-wrapper، fixed را در محدوده کوچک ویدئو حبس می‌کرد.
  const portalContainer = getPortalContainer(isIOS, isFullscreen);

  return ReactDOM.createPortal(
    <div className="mobile-fullscreen-overlay" onClick={handleBackdropClick}>
      <div className="mobile-fullscreen-prompt" onClick={handlePromptClick}>
        <div className="prompt-header">
          <i className="fas fa-expand-arrows-alt"></i>
          <h3>{title}</h3>
        </div>

        <div className="prompt-body">
          <p>{bodyText2}</p>
        </div>

        <div className="prompt-actions">
          <button className="prompt-btn accept-btn" onClick={onAccept}>
            <i className="fas fa-expand"></i>
            {acceptText}
          </button>
          <button className="prompt-btn decline-btn" onClick={onDecline}>
            <i className="fas fa-times"></i>
            {declineText}
          </button>
        </div>
      </div>
    </div>,
    portalContainer,
  );
};

export default MobileFullscreenPrompt;
